import {useState, useMemo, useEffect} from 'react'
import MainLayout from "../../../commons/layout/MainLayout/index";
import { useNavigate, useLocation } from "react-router-dom";
import ROUTERS from "../../../commons/constans/router";
import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import TabsComponent from "../../../commons/components/Tabs/TabsComponent";
import AllTab from "./../components/allTab";
import AlbumTab from "./../components/albumTab";
import SelfieTab from "./../components/selfieTab";
import VideoTab from "./../components/videoTab";
import NoItem from "./../components/NoItem";
import { useAlbum } from "./../../../commons/customHooks/Album"
import { useUser } from "./../../../commons/customHooks/Account"
import {useDispatch, useSelector} from 'react-redux';
import {resetChooseCoupon} from "../../Giftbox/redux/actions";

type Props = {
  footerShow: Boolean,
};

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const TYPE = {
  0: null,
  1: 'image_card',
  2: 'character_selfie',
  3: 'video_message',
}

const TYPE_TO_ID = {
  'image_card': 1,
  'character_selfie': 2,
  'video_message': 3,
}

const AlbumPageContainer = ({ footerShow }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let query = useQuery();

  const [params, setParams] = useState({
    type: query.get('type') ?? null,
    limit: 3,
    page: 1,
    group_by: 'date',
  })

  const [activeIndex, setActiveIndex] = useState(TYPE_TO_ID[query.get('type')] ?? 0)
  const [photoSelected, setPhotoSelected] = useState(null)
  const [albums, isProcessing, lastPage, currentPage] = useAlbum(params)
  const {isProcessingDel} = useSelector((state) => state.videoDetailReducers);

  const { user } = useUser();

  useEffect(() => {
    dispatch(resetChooseCoupon())
    // if (params && params.page > 2) {
    //   scrollTo(0, 0);
    // }
  },[])

  useEffect(() => {
    const callFetchAlbumData = () => {
      setParams(p => ({...p}))
    }

    window.callFetchAlbumData = callFetchAlbumData

    return () => {
      window.callFetchAlbumData = undefined
    }
  },[]);

  const handleLeftClick = () => {
    if (location.state?.selectImage) {
      navigate(ROUTERS.AWARD_REGISTER, {state: {data: location.state.data}});
    } else {
      navigate(ROUTERS.HOME);
    }
  };

  const handleLabelRight = () => {
    navigate(ROUTERS.AWARD_REGISTER, {state: {photoSelected, data: location.state.data}});
  };

  const handleChangeTab = (e) => {
    if (e === TYPE_TO_ID[params.type] || (e === 0 && params.type === null)) {
      return
    }
    setParams(p => ({...p, type: TYPE[e], page: 1}))
    setActiveIndex(e)
    navigate(location.pathname + '?type=' + (TYPE[e] ?? ''), {state: location.state})
  }

  const handleDetailVideo = (id) => {
    navigate(ROUTERS.VIDEO_DETAIL_PATH(id), {state: {prevPath: 'prevPath'}});
  }

  const onPhotoClick = (photo) => {
    if (location.state?.selectImage) {
      if (photoSelected && photo.id === photoSelected.id) {
        setPhotoSelected(null)
      } else {
        setPhotoSelected(photo)
      }
    } else {
      navigate(ROUTERS.ALBUM_DETAIL_PATH(photo.id));
    }
  }

  const fetchMoreDataPaginate = (data) => {
    setParams({...params, ...data});
  }

  const allTab = (
    <AllTab
      data={albums.all ?? {}}
      handleDetailVideo={handleDetailVideo}
      onPhotoClick={location.state?.selectImage ? onPhotoClick : null}
      photoSelected={photoSelected}
      showVideo={!location.state?.selectImage}
      isProcessing={isProcessing}
      isProcessingDel={isProcessingDel}
      params={params}
      fetchMoreDataPaginate={fetchMoreDataPaginate}
      lastPage={lastPage}
      currentPage={currentPage}
    />
  );

  const albumTab = (
    <AlbumTab
      dataAlbum={albums.image_card && !Array.isArray(albums.image_card) ? albums.image_card : {}}
      onPhotoClick={location.state?.selectImage ? onPhotoClick : null}
      photoSelected={photoSelected}
      showVideo={!location.state?.selectImage}
      isProcessing={isProcessing}
      params={params}
      fetchMoreDataPaginate={fetchMoreDataPaginate}
      lastPage={lastPage}
      currentPage={currentPage}
    />
  );

  const characterSelfieTab = (
    <SelfieTab
      dataAlbum={albums.character_selfie && !Array.isArray(albums.character_selfie) ? albums.character_selfie : {}}
      onPhotoClick={location.state?.selectImage ? onPhotoClick : null}
      photoSelected={photoSelected}
      showVideo={!location.state?.selectImage}
      isProcessing={isProcessing}
      params={params}
      fetchMoreDataPaginate={fetchMoreDataPaginate}
      lastPage={lastPage}
      currentPage={currentPage}
    />
  );

  const videoTab =
    <VideoTab
      dataVideo={albums.video_message && !Array.isArray(albums.video_message) ? albums.video_message : {}} 
      handleDetailVideo={handleDetailVideo}
      isProcessing={isProcessing}
      params={params}
      fetchMoreDataPaginate={fetchMoreDataPaginate}
      lastPage={lastPage}
      currentPage={currentPage}
      isProcessingDel={isProcessingDel}
    />

  let tabHeadings = ["전체", "카드사진", "캐릭터셀카", "영상편지"]
  let tabContents = [allTab, albumTab, characterSelfieTab, videoTab]
  if (location.state?.selectImage) {
    tabHeadings = ["전체", "카드사진", "캐릭터셀카"]
    tabContents = [allTab, albumTab, characterSelfieTab]
  }

  let content = null;
  let showMenu = true;
  let checkAlbumAll = [];

  Object.keys(albums.all ?? {}).map((day) => {
    albums?.all[day].map(e => {
      if (e.type !== "video_message") {
        checkAlbumAll = [...checkAlbumAll, e]
      }
    })
  });

  if (Array.isArray(albums?.character_selfie)) {
    checkAlbumAll = [...checkAlbumAll, ...albums?.character_selfie]
  } else {
    Object.keys(albums.character_selfie ?? {}).map((day) => {
      if (albums.character_selfie.length > 0 && albums?.character_selfie[day]) {
        (albums?.character_selfie[day] || []).map(e => {
          if (e.type !== "video_message") {
            checkAlbumAll = [...checkAlbumAll, e]
          }
        })
      }
    });
  }
  
  if (Array.isArray(albums?.image_card)) {
    checkAlbumAll = [...checkAlbumAll, ...albums?.image_card]
  } else {
    Object.keys(albums.image_card ?? {}).map((day) => {
      if (albums.image_card.length > 0 && albums?.image_card[day]) {
        (albums?.image_card[day] || []).map(e => {
          if (e.type !== "video_message") {
            checkAlbumAll = [...checkAlbumAll, e]
          }
        })
      }
    });
  }

  if (location.state?.selectImage && !isProcessing && checkAlbumAll) {
    if (!checkAlbumAll.length) {
      showMenu = false
      content = (
        <NoItem />
      )
    }
  } 
  if (!content) {
    showMenu = true
    content = <TabsComponent
      tabHeadings={tabHeadings}
      tabContents={tabContents}
      activeIndex={activeIndex}
      handleChangeTab={handleChangeTab}
      user={user}
    />
  }

  return (
    <MainLayout
      pageID={"album-page"}
      displayBottomNav={showMenu}
      activeNav={"ALBUM"}
    >
      <HeaderHs2
        labelRight={photoSelected ? '선택완료' : null}
        labelLeft={true}
        title="앨범"
        handleLabelLeft={() => handleLeftClick()}
        handleLabelRight={() => handleLabelRight()}
      />
      <div className="wrapper">
        {(!(isProcessing && location.state?.selectImage) || checkAlbumAll.length) ? content : null}
      </div>
    </MainLayout>
  );
};

export default AlbumPageContainer;
